import { Checkbox, Icon, InputGroup, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import Clearfix from 'components/elements/clearfix';
import TagInput from 'components/elements/input-tag';
import PhoneNumber from 'components/elements/phone-number';
import IconRequired from 'components/elements/required-icon';
// import FacilitySelect from 'components/elements/select-facility';
import KhuCumCongNghiepSelect from 'components/elements/select-khu-cum-cong-nghiep';
import NganhNgheSelect from 'components/elements/select-nganh-nghe';
import SelectNguonThai1 from 'components/elements/select-nguon-thai-1';
import SelectNguonThai2 from 'components/elements/select-nguon-thai-2';
import PhuongXaSelect from 'components/elements/select-phuong-xa';
//*/
import QuanHuyenSelect from 'components/elements/select-quan-huyen';
import ThamQuyenQuanLy from 'components/elements/select-tham-quyen-quan-ly';
import SelectTinhTrangHoatDong from 'components/elements/select-tinh-trang-hoat-dong';
import { IS_ENTERPRISE } from 'config';
// import * as _ from 'lodash';
// import { Link } from 'react-router-dom';
// import slug from 'constants/slug';
import { COLOR, SELECT_ITEM_DEFAULT } from 'config';
import PropTypes from 'prop-types';
import { createForm } from 'rc-form';
import NumberInput from 'rc-input-number';
import React from 'react';
import { Col, Row } from 'reactstrap';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

const ColCheckBox = styled(Col)`
  display: flex;
  align-items: center;

  .bp3-checkbox {
    margin: 0;
  }
`;

class CosoForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    handelSubmitSearch: PropTypes.func,
  };

  constructor(props) {
    super(props);

    let isKhuCongNghiep = true;
    let industrialAreaName = _.result(
      this.props,
      'initialValue.industrialArea.Name'
    );

    if (industrialAreaName && industrialAreaName.startsWith('CỤM'))
      isKhuCongNghiep = false;

    this.state = {
      ...this.state,
      isKhuCongNghiep,
    };
  }

  setInitialValue(keyPath, defaultValue) {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      if (!value) value = defaultValue;
      return value;
    }
    return defaultValue;
  }

  setSelInitialValue(keyPath, defaultValue, nameLabel) {
    if (this.props.isEdit) {
      let selItem = _.result(this.props.initialValue, keyPath);
      if (!selItem) return defaultValue;
      return {
        value: selItem._id || selItem.value,
        label: nameLabel ? selItem[nameLabel] : selItem.Name || selItem.label,
      };
    }
    return defaultValue;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      console.log(error);
      if (error) return;
      value.district = _.get(value.district, 'value', null);
      value.sector = _.get(value.sector, 'value', null);
      value.industrialArea = _.get(value.industrialArea, 'value', null);
      value.authority = _.get(value.authority, 'value', null);
      value.Commune = _.get(value.Commune, 'value', null);
      value.FrequencyOfMonitoring = _.get(value.FrequencyOfMonitoring, 'value');
      value.facilityParent = _.get(value.facilityParent, 'value', null);
      value.ReceviedSource_1 = _.get(value.ReceviedSource_1, 'value', null);
      value.ReceviedSource_2 = _.get(value.ReceviedSource_2, 'value', null);

      if (!value.PContactTel) value.PContactTel = null;
      if (!value.SContactTel) value.SContactTel = null;

      if (this.props.handelSubmitSearch) this.props.handelSubmitSearch(value);
    });
  };

  render() {
    const { getFieldProps, getFieldValue, getFieldError, setFieldsValue } =
      this.props.form;

    return (
      <div>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={this.submit}
                style={{ color: COLOR.SUCCESS }}
              />
              <Clearfix width={8} />
              {/* <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}> */}
              <Icon
                onClick={() => {
                  window.history.back();
                }}
                icon={IconNames.DISABLE}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
              />
              {/* </Link> */}
            </HeaderContainer>
          </Col>
        </Row>

        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>Tên doanh nghiệp</LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  placeholder='Tên doanh nghiệp'
                  {...getFieldProps('organizationName', {
                    initialValue: this.setInitialValue('organizationName', ''),
                  })}
                />
                <ErrorContainer>
                  {(getFieldError('organizationName') || []).join(', ')}
                </ErrorContainer>
              </Col>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Tên cơ sở/dự án'
              {...getFieldProps('FacilityNameFull', {
                initialValue: this.setInitialValue('FacilityNameFull', ''),
                rules: [
                  {
                    validator: (rule, val, callback) => {
                      if (!(val || '').trim())
                        callback(new Error('Vui lòng nhập Tên cơ sở'));
                      callback();
                    },
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('FacilityNameFull') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Số giấy phép chứng nhận đăng ký doanh nghiệp
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Số giấy phép chứng nhận đăng ký doanh nghiệp'
              {...getFieldProps('BusinessLicenseNumber', {
                initialValue: this.setInitialValue('BusinessLicenseNumber', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Mã số thuế (Mã số doanh nghiệp)</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Mã số thuế (Mã số doanh nghiệp) '
              {...getFieldProps('taxNumber', {
                initialValue: this.setInitialValue('taxNumber', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              {IS_ENTERPRISE ? 'Phân khu' : 'KCN/CCN'}
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <KhuCumCongNghiepSelect
              onChangeIsKhuCongNghiep={(val) => {
                this.setState({
                  isKhuCongNghiep: val,
                });
                setFieldsValue({
                  industrialArea: SELECT_ITEM_DEFAULT,
                });
              }}
              isKhuCongNghiep={this.state.isKhuCongNghiep}
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'industrialArea',
                option: {
                  initialValue: this.setSelInitialValue(
                    'industrialArea',
                    SELECT_ITEM_DEFAULT
                  ),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>Thẩm quyền quản lý môi trường</LabelContainer>
              </Col>
              <Col xs={4}>
                <ThamQuyenQuanLy
                  hideLabel
                  fieldForm={{
                    form: this.props.form,
                    name: 'authority',
                    option: {
                      initialValue: this.setSelInitialValue(
                        'authority',
                        SELECT_ITEM_DEFAULT
                      ),
                    },
                  }}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <Row>
          <Col xs={4}>
            <LabelContainer>Tình trạng hoạt động</LabelContainer>
          </Col>
          <Col xs={4}>
            <SelectTinhTrangHoatDong
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'businessActivity',
                option: {
                  initialValue: this.setSelInitialValue(
                    'businessActivity',
                    SELECT_ITEM_DEFAULT
                  ),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ngành/Nghề</LabelContainer>
          </Col>
          <Col xs={4}>
            <NganhNgheSelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'sector',
                option: {
                  initialValue: this.setSelInitialValue(
                    'sector',
                    SELECT_ITEM_DEFAULT
                  ),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Điện thoại</LabelContainer>
          </Col>
          <Col xs={4}>
            <PhoneNumber
              fill
              placeholder='Điện thoại'
              {...getFieldProps('Telephone', {
                initialValue: this.setInitialValue('Telephone', ''),
                rules: [
                  {
                    pattern: '^(0|84|02|\\+84)?[1-9][0-9]{8}$',
                    message: 'Điện thoại sai định dạng',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('Telephone') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Fax</LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder='Fax'
              {...getFieldProps('Fax', {
                initialValue: this.setInitialValue('Fax', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Diện tích (m²)</LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              min={0}
              placeholder='Diện tích (m²)'
              {...getFieldProps('Aream2', {
                initialValue: this.setInitialValue('Aream2', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Vĩ độ (WGS84)</LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder='Vĩ độ (WGS84)'
              min={-90}
              max={90}
              {...getFieldProps('Latitude', {
                initialValue: this.setInitialValue('Latitude', ''),
              })}
            />
            <div class='bp3-form-helper-text' style={{ paddingTop: '4px' }}>
              Vui lòng nhập Vĩ độ (WGS84) để hiển thị cơ sở/dự án tại mục Bản đồ
            </div>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Kinh độ (WGS84)</LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder='Kinh độ (WGS84)'
              min={0}
              max={360}
              {...getFieldProps('Longitude', {
                initialValue: this.setInitialValue('Longitude', ''),
              })}
            />
            <div class='bp3-form-helper-text' style={{ paddingTop: '4px' }}>
              Vui lòng nhập Kinh độ (WGS84) để hiển thị cơ sở/dự án tại mục Bản
              đồ
            </div>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Vĩ độ (VN2000)</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Vĩ độ (VN2000)'
              {...getFieldProps('LatitudeVN2000', {
                initialValue: this.setInitialValue('LatitudeVN2000', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Kinh độ (VN2000)</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Kinh độ (VN2000)'
              {...getFieldProps('LongitudeVN2000', {
                initialValue: this.setInitialValue('LongitudeVN2000', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>Quận/Huyện</LabelContainer>
              </Col>
              <Col xs={4}>
                <QuanHuyenSelect
                  hideLabel
                  fieldForm={{
                    form: this.props.form,
                    name: 'district',
                    option: {
                      initialValue: this.setSelInitialValue(
                        'district',
                        SELECT_ITEM_DEFAULT
                      ),
                      onChange: (value) => {
                        setFieldsValue({
                          Commune: SELECT_ITEM_DEFAULT,
                        });
                      },
                    },
                  }}
                />
                <div class='bp3-form-helper-text' style={{ paddingTop: '4px' }}>
                  Vui lòng chọn Quận/Huyện để tra cứu cơ sở/dự án tại mục Bản đồ
                </div>
              </Col>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>Phường/Xã</LabelContainer>
              </Col>
              <Col xs={4}>
                <PhuongXaSelect
                  quanHuyenTarget={
                    getFieldValue('district')
                      ? getFieldValue('district').value
                      : this.setInitialValue('district._id', null)
                  }
                  hideLabel
                  fieldForm={{
                    form: this.props.form,
                    name: 'Commune',
                    option: {
                      initialValue:
                        this.props.isEdit &&
                        _.get(this.props.initialValue, 'Commune')
                          ? {
                              value: this.props.initialValue.Commune,
                              label: this.props.initialValue.Commune,
                            }
                          : SELECT_ITEM_DEFAULT,
                    },
                  }}
                />
                <div class='bp3-form-helper-text' style={{ paddingTop: '4px' }}>
                  Vui lòng chọn Phường/Xã để tra cứu cơ sở/dự án tại mục Bản đồ
                </div>
              </Col>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <Row>
          <Col xs={4}>
            <LabelContainer>Địa chỉ</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Địa chỉ'
              {...getFieldProps('Address1', {
                initialValue: this.setInitialValue('Address1', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>Nguồn tiếp nhận 2</LabelContainer>
              </Col>
              <Col xs={4}>
                <SelectNguonThai2
                  hideLabel
                  fieldForm={{
                    form: this.props.form,
                    name: 'ReceviedSource_2',
                    option: {
                      initialValue: this.setSelInitialValue(
                        'ReceviedSource_2',
                        SELECT_ITEM_DEFAULT
                      ),
                    },
                  }}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
            <Row>
              <Col xs={4}>
                <LabelContainer>Nguồn tiếp nhận 1</LabelContainer>
              </Col>
              <Col xs={4}>
                <SelectNguonThai1
                  hideLabel
                  fieldForm={{
                    form: this.props.form,
                    name: 'ReceviedSource_1',
                    option: {
                      initialValue: this.setSelInitialValue(
                        'ReceviedSource_1',
                        SELECT_ITEM_DEFAULT
                      ),
                    },
                  }}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <Row>
          <Col xs={4}>
            <LabelContainer>
              {IS_ENTERPRISE ? 'Loại nước thải' : 'Nguồn thải'}
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder={IS_ENTERPRISE ? 'Loại nước thải' : 'Nguồn thải'}
              {...getFieldProps('WasteSources', {
                initialValue: this.setInitialValue('WasteSources', ''),
              })}
            />
          </Col>
        </Row>
        {IS_ENTERPRISE && (
          <React.Fragment>
            <Clearfix height={8} />
            <Row>
              <Col xs={4}>
                <LabelContainer>
                  Tiêu chuẩn đấu nối nước thải theo SLA
                </LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  placeholder='Tiêu chuẩn đấu nối nước thải theo SLA'
                  {...getFieldProps('WastewaterSLAConnectionStandard', {
                    initialValue: this.setInitialValue(
                      'WastewaterSLAConnectionStandard',
                      ''
                    ),
                  })}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
            <Row>
              <Col xs={4}>
                <LabelContainer>
                  Tiêu chuẩn đấu nối nước thải theo ĐTM
                </LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  placeholder='Tiêu chuẩn đấu nối nước thải theo ĐTM'
                  {...getFieldProps('WastewaterDTMConnectionStandard', {
                    initialValue: this.setInitialValue(
                      'WastewaterDTMConnectionStandard',
                      ''
                    ),
                  })}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
            <Row>
              <Col xs={4}>
                <LabelContainer>
                  Lưu lượng nước thải đăng ký theo ĐTM của DN (m3/ngày)
                </LabelContainer>
              </Col>
              <Col xs={4}>
                <NumberInput
                  placeholder='Lưu lượng nước thải đăng ký theo ĐTM của DN (m3/ngày)'
                  {...getFieldProps('RegisteredFlowRateDTM', {
                    initialValue: this.setInitialValue(
                      'RegisteredFlowRateDTM',
                      ''
                    ),
                  })}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
            <Row>
              <Col xs={4}>
                <LabelContainer>Ghi chú</LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  placeholder='Ghi chú'
                  {...getFieldProps('Note', {
                    initialValue: this.setInitialValue('Note', ''),
                  })}
                />
              </Col>
            </Row>
          </React.Fragment>
        )}

        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>
                  <b>Thông tin thu phí</b>
                </LabelContainer>
              </Col>
              <ColCheckBox xs={4}>
                <Checkbox
                  {...getFieldProps('isPaidFee', {
                    initialValue: this.setInitialValue('isPaidFee'),
                    valuePropName: 'checked',
                  })}
                >
                  Đã đóng phí
                </Checkbox>
              </ColCheckBox>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <Row>
          <Col xs={4}>
            <LabelContainer>
              <b>Cán bộ phụ trách môi trường</b>
            </LabelContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Họ và tên</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Họ và tên'
              {...getFieldProps('PContactFirst', {
                initialValue: this.setInitialValue('PContactFirst', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Điện thoại</LabelContainer>
          </Col>
          <Col xs={4}>
            <PhoneNumber
              fill
              placeholder='Điện thoại'
              {...getFieldProps('PContactTel', {
                initialValue: this.setInitialValue('PContactTel', ''),
                rules: [
                  {
                    pattern: '^(0|84|02|\\+84)?[1-9][0-9]{8}$',
                    message: 'Điện thoại sai định dạng',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('PContactTel') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Email</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Email'
              {...getFieldProps('PContactEmail', {
                initialValue: this.setInitialValue('PContactEmail', ''),
                rules: [
                  {
                    type: 'email',
                    message: 'định dạng email không đúng',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('PContactEmail') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              <b>Người đại diện pháp luật </b>
            </LabelContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Họ và tên</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Họ và tên'
              {...getFieldProps('SContactFirst', {
                initialValue: this.setInitialValue('SContactFirst', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Điện thoại</LabelContainer>
          </Col>
          <Col xs={4}>
            <PhoneNumber
              fill
              placeholder='Điện thoại'
              {...getFieldProps('SContactTel', {
                initialValue: this.setInitialValue('SContactTel', ''),
                rules: [
                  {
                    pattern: '^(0|84|02|\\+84)?[1-9][0-9]{8}$',
                    message: 'Điện thoại sai định dạng',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('SContactTel') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Email</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Email'
              {...getFieldProps('SContactEmail', {
                initialValue: this.setInitialValue('SContactEmail', ''),
                rules: [
                  {
                    type: 'email',
                    message: 'định dạng email không đúng',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('SContactEmail') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Clearfix height={8} />
            <Row>
              <Col xs={4}>
                <LabelContainer>
                  <b>Quản lý thông tin số giấy phép</b>
                </LabelContainer>
              </Col>
            </Row>
            <Clearfix height={8} />
            <Row>
              <Col xs={4}>
                <LabelContainer>Số giấy phép</LabelContainer>
              </Col>
              <Col xs={4}>
                <TagInput
                  LicenseNumberUsed={this.setInitialValue(
                    'LicenseNumberUsed',
                    []
                  )}
                  placeholder='Số giấy phép'
                  {...getFieldProps('LicenseNumber', {
                    initialValue: this.setInitialValue('LicenseNumber', []),
                  })}
                />
              </Col>
            </Row>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default createForm()(CosoForm);



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoForm/index.js